/*
  Turns one clause of a collection's collectioQuery metafield into Solr syntax.

  A clause is 'field:value', and the value may be an OR list:
      variantOptions:8' X 11' OR 8' X 10'
  The previous version wrapped everything after the colon in a single phrase, so
  Solr searched for one literal value -- "8' X 11' OR 8' X 10'" -- and size
  collections such as /collections/8-x-10 rendered an empty grid while Shopify
  showed 250 products in them. Each value becomes its own phrase instead.

  Splitting on the first colon only, since a value may legitimately contain one.

  Escaping is backslash-only on purpose: collectioTitle is passed through
  encodeURI() further down, which percent-encodes the " and \\ this produces.
  Percent-encoding here would be encoded a second time and reach Solr as %22.
*/
function buildQueryClause(clause) {
  var raw = String(clause == null ? '' : clause);
  var split = raw.indexOf(':');
  if (split === -1) { return ''; }
  var field = raw.slice(0, split).trim();
  var values = raw.slice(split + 1).split(/\s+OR\s+/);
  var phrases = [];
  for (var i = 0; i < values.length; i++) {
    /*
      Strip any escaping already present before re-escaping. Metafields get
      hand-written, and an inch mark is often typed as \" by someone protecting
      it — which used to survive into the query, so Solr looked for a literal
      backslash and the clause matched nothing. No size contains a real
      backslash, so unescaping first is safe and both spellings now work.
    */
    var v = values[i].replace(/\\(["\\])/g, '$1').trim();
    if (v) { phrases.push('"' + v.replace(/(["\\])/g, '\\$1') + '"'); }
  }
  if (!phrases.length || !field) { return ''; }
  return field + ':(' + phrases.join(' OR ') + ')';
}

if(collectioTitle === "Products") {
  collectioTitle = "*:*";
  console.log('1'+collectioTitle);
} else {
  if(collectioTitle.indexOf("-")) {
    collectioTitle = collectioTitle.replace(/-/g, '/');
    console.log('2'+collectioTitle);
  }
  if(collectioTitle.includes('Outlet')){
    collectioTitle = 'plpProductCallout:"ONLINE OUTLET"';
  }
  else{
    if(collectioQuery) {
      console.log('3'+collectioQuery);
      const collectionQueryArray = collectioQuery.split("|");
      collectioTitle = buildQueryClause(collectionQueryArray[0]);
      if(collectionQueryArray.length > 1) {
        var subClause = buildQueryClause(collectionQueryArray[1]);
        if (subClause) {
          collectioTitle = collectioTitle + ' AND ' + subClause;
        }
      }
    } else {
      collectioTitle = 'product_type:"' + collectioTitle+ '" OR ' + 'product_sub_type:"' + collectioTitle + '"';
    }
  }
}

collectioTitle = encodeURI(collectioTitle);
/*
  ?preview_prices=1 shows card prices for products the service still reports as
  available_online:false, so price/range presentation can be reviewed before the
  sell-on-web metafield is set. Display only — it does not enable purchasing,
  so those cards keep their "Contact a Flooring Expert" action.
*/
var RR_PREVIEW_PRICES = /[?&]preview_prices=1/.test(window.location.search);

var productPerPage = 24;
var totalResults;
var currentstart = 0;
var currentrows = productPerPage;
var sortOption = "price%20desc";
var selectedFields = new Map();
var baseProductUrl = serviceUrl + "/search?q=productEnabled:true AND "+collectioTitle+"&start="+currentstart +"&rows=" + currentrows + "&sort=price%20asc";
var filterProductUrl = serviceUrl + "/search?q="+collectioTitle+"&fq=meta-product-color:cape&start="+currentstart+"&rows="+currentrows;
var filteredResults;
function sortProducts(sort){
currentstart = 0;
sortOption = sort.value;
fetchSearchResults();
}
/*
  Server-rendered grid (SEO).

  templates/collection.liquid now renders the first page of products in Liquid so
  the served HTML contains real product links. The service is still what powers
  faceting, so it is still queried on load — but on a clean URL that response
  must only build the facet sidebar, never replace the grid, or the crawlable
  markup is wiped a moment after paint.

  RR_SSR_GRID_ACTIVE is true while the server-rendered cards are on screen. Any
  user filter/sort/page action calls buildFilteredProducts(), which takes over
  the container and clears the flag for the rest of the session.
*/
var RR_SSR_GRID_ACTIVE = (function () {
  var el = document.getElementById('js-product-container');
  if (!el || el.getAttribute('data-ssr-grid') !== 'true') return false;
  // ?pg=N is the JS pagination; that view has to be rendered by the service.
  return !/[?&]pg=/.test(window.location.search);
})();

/*
  One-shot: only the automatic request made on page load may skip rendering the
  grid. Every later request is a deliberate filter / sort / page action and must
  render, so this is consumed by the first response.

  These have to be two separate flags. Gating the response on
  RR_SSR_GRID_ACTIVE alone deadlocks: the early return skips
  buildFilteredProducts(), which is the only thing that clears the flag, so
  filtering silently returned facets and left the grid untouched.
*/
var RR_SSR_SKIP_FIRST_GRID = RR_SSR_GRID_ACTIVE;

/* Favourites live in localStorage, so server-rendered stars start unset. */
function rrHydrateSsrFavourites() {
  $('[data-fav]').each(function () {
    var $el = $(this);
    var data;
    try { data = JSON.parse($el.attr('data-fav')); } catch (e) { return; }
    var isFav = checkIfFav(data.handle);
    data.isFav = isFav;
    $el.attr('data-fav', JSON.stringify(data));
    $el.attr('aria-pressed', isFav ? 'true' : 'false');
    $el.attr('aria-label', isFav ? 'Remove from Favorites' : 'Add to Favorites');
    $el.find('i').attr('class', isFav ? 'fas fa-star' : 'fal fa-star');
  });
}

$(document).on('click', '[data-fav]', function (e) {
  e.preventDefault();
  var data;
  try { data = JSON.parse($(this).attr('data-fav')); } catch (e2) { return; }
  toggleFav(data);
});

function getFilterProducts(productUrl){
  $.ajax({
      type: 'GET',
      url: productUrl,
      dataType: 'json',
      success: function(res){
          //filterProducts(res.response.docs, tag)
          filteredResults = res.response.docs;
          if (RR_SSR_SKIP_FIRST_GRID) {
            // Initial load only: keep the server-rendered grid and its ?page=
            // links, take just the facets.
            RR_SSR_SKIP_FIRST_GRID = false;
            buildFacetForProducts(res.facet_counts.facet_fields, res.response.numFound);
            return;
          }
          buildFilteredProducts(filteredResults);
          buildFacetForProducts(res.facet_counts.facet_fields, res.response.numFound);
          buildPagination(res.response.numFound, res.response.start);
       },
      error: function(status){
           console.log(status);
      }
  })
}

function filterProducts(products, tag) {
  var filteredProducts = products.filter(function(product){
      return product.tags.indexOf(tag) > -1;
  });

}

function buildPagination(totalProducts, start) {
      var $productPaginationContainer = $('#productPagination');
      $productPaginationContainer.empty();
      const maxPagesToShow = 5;
      var products = [],
      product = {}, 
      data = {}, 
      source = $("#productPaginationTemplate").html(),
      template = Handlebars.compile(source);
      var pagination = {};
      var totalpages = Math.ceil(totalProducts/productPerPage);
      var pages = [];
      if(totalProducts > 0) {
          var currentPage = (start/productPerPage) + 1;
          pagination.nextactive = currentPage > 0 && currentPage < totalpages;
          pagination.prevactive = currentPage > 1;
          pagination.nextPage = currentPage + 1;
          pagination.prevPage = currentPage -1;
          let pagesToShow = maxPagesToShow;
          let startIdex = 1;
          if(totalpages <= maxPagesToShow) {
            pagesToShow = totalpages;
          } else {
            if(currentPage >= maxPagesToShow) {
              startIdex = currentPage-2;
              pagesToShow = currentPage + maxPagesToShow -3;
            } else {
              startIdex = 1;
            }
            if(pagesToShow >= totalpages) {
              pagesToShow = totalpages;
              startIdex = currentPage-(maxPagesToShow - 1);
            }
          }
          for(var i=startIdex; i<=pagesToShow; i++) {
            var page = {};
            page.label = i;
            page.active = (i === currentPage);
            pages.push(page);
          }
      }
      pagination.pages = pages;
      pagination.lastpage = totalpages;
      pagination.firstpage = 1;
      
  data = {
    pagination: pagination
  } 

  $productPaginationContainer.append(template(data));
}

function fetchSearchResults(){
const filterQuery = formQuery();
getFilterProducts(filterQuery);
}

function fetchPage(pageNumber) {
  if(pageNumber !== 1) {
    console.log(location.search+"-"+pageNumber)
    history.pushState(null, "", "?pg=" + pageNumber);
  } else {
    location.search = '';
  }
  currentstart = (pageNumber - 1) * productPerPage;
  currentrow = productPerPage;
  fetchSearchResults();
  window.scroll({top: 0, left: 0, behavior: 'smooth' });
}

function buildFilteredProducts(filteredProds) {
  var $productContainer = $('#js-product-container');
      // The JS grid replaces the server-rendered one from here on.
      RR_SSR_GRID_ACTIVE = false;
      $productContainer.removeAttr('data-ssr-grid');
      $('.ssr-pagination').remove();
      $productContainer.empty();
      var products = [],
      product = {}, 
      data = {}, 
      source = $("#ProductTemplate").html(),
      template = Handlebars.compile(source);
      products = filteredProds.map(function(productItem) {   
          return product = {
              id: productItem['productId'], 
              //description: productItem.body_html[0].replace(/<\/?[^>]+(>|$)/g, "").split(' ').join(' '), 
              title: productItem['title'],
              color: productItem['color'],
              //price: Shopify.formatMoney(productItem.price[0], {{ shop.money_format | json }})
              showPrice: (RR_PREVIEW_PRICES || productItem['available_online'][0]) && productItem['price'][0] !== 0,
              sellOnWeb: productItem['available_online'] && productItem['available_online'][0] && productItem['price'][0] !== 0 ? true : false,
              price: productItem['coveragePerBox'] && productItem['coveragePerBox'][0] !== 0 ? (productItem['price'][0]/productItem['coveragePerBox'][0]).toFixed(2) : productItem['price'][0].toFixed(2),
              coveragePerBox: productItem['coveragePerBox'] && productItem['coveragePerBox'][0] !== 0 ? true: false,
              // Area Rugs are sold each and carry one variant per size, so the
              // service's single `price` is only the cheapest size. Flagged here
              // and resolved to a real range by enhancePriceRanges() after render.
              showPriceRange: productItem['product_type'] === 'Area Rug',
              productCalloutTxt: (productItem['plpProductCallout'] && productItem['plpProductCallout'][0]!=='NA') ? productItem['plpProductCallout'][0] : "",
              showProductCallout: productItem['plpProductCallout'] && productItem['plpProductCallout'][0] !== 'NA',
              url: '/products/' + productItem['handle'],
              imgUrl: productItem['imageUrl'],
              roomImageUrl: productItem['roomImageUrl'] ?  productItem['roomImageUrl'][0] : "",
              handle: productItem['handle'],
              style: productItem['style'],
              isFav: checkIfFav(productItem['handle'])
          }
      });
      
  data = {
      product: products
  }

  $productContainer.append(template(data));
  enhanceSampleButtons();
  enhanceProductCards();
}

/*
  Facet values become element ids and then jQuery selectors ('#' + id), so the
  result has to be a valid CSS identifier — not merely free of spaces. The old
  rule replaced only space / . , so Area Rug sizes broke it two ways:
  "10' X 14'" became 10'-X-14', whose apostrophes threw "unrecognized
  expression" out of Sizzle in populateCheckedFields() and also closed the
  quoted argument in the removeFilter() onclick. An identifier may not start
  with a digit either, which every rug size does, hence the prefix.

  Ids are in-memory only — never in a URL or stored — so changing the format
  breaks no links.
*/
function convertToId(value) {
  var raw = String(value);
  /*
    The suffix keeps ids unique. Stripping punctuation collapses values the
    catalogue genuinely distinguishes — "6 in" / "6 in." and "Grey Silver" /
    "Grey/Silver" both exist — and duplicate ids send every label click and
    every '#' + id lookup to the first checkbox. Hashing the raw value rather
    than using the loop index keeps an id stable when faceting reorders the
    list, which is what populateCheckedFields() relies on to re-check boxes.
  */
  var hash = 0;
  for (var i = 0; i < raw.length; i++) {
    hash = ((hash << 5) - hash + raw.charCodeAt(i)) | 0;
  }
  return 'f-' + raw.replace(/[^A-Za-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '') +
    '-' + (hash >>> 0).toString(36);
}

function mapFilterHeadings(filterLabel){
  if(filterLabel === "Install Method") {
    return "Installation Method";
  }
  if(filterLabel === "MadeInUSA") {
    return "Made In USA";
  }
  if(filterLabel === "Product Sub Type") {
    return "Type";
  }
  if(filterLabel === "Vendor") {
    return "Brand";
  }
  if(filterLabel === "VariantOptions") {
    return "Size";
  }
  /*
    The curated Area Rug facets. These replace the raw fields they were built
    from — sizeFilters instead of the 92 spellings in variantOptions,
    colorFilters instead of color_family — so they take those labels.
  */
  if(filterLabel === "SizeFilters") {
    return "Size";
  }
  if(filterLabel === "ColorFilters") {
    return "Color";
  }
  if(filterLabel === "ShapeFilters") {
    return "Shape";
  }
  if(filterLabel === "StyleFilters") {
    return "Style";
  }
  if(filterLabel === "LifeStyleRooms") {
    return "Room";
  }
  if(filterLabel === "MaterialTypes") {
    return "Material Type";
  }
  if(filterLabel === "PetFriendly") {
    return "Pet Friendly";
  }
  if(filterLabel === "EcoFriendly") {
    return "Eco Friendly";
  }
  if(filterLabel === "CountryOrigin") {
    return "Country Of Origin";
  }
  if(filterLabel === "MachineWashable") {
    return "Machine Washable";
  }
  if(filterLabel === "IndoorOutdoor") {
    return "Indoor / Outdoor";
  }
  return filterLabel;
}

/*
  Facet fields the service returns but the sidebar does not show. Country of
  origin and Made in USA are single-value panels that filter nothing useful,
  and Type repeats the collection the shopper is already in.

  Matched on the lower-cased field name, so a spelling change in the service
  ('madeInUSA' vs 'made_in_usa') still matches. countryOfOrigin is listed
  alongside countryOrigin because only the latter exists today and the other is
  the name people expect.
*/
var RR_HIDDEN_FACETS = [
  'product_sub_type',
  'madeinusa',
  'countryorigin',
  'countryoforigin',
  /*
    Backing and Border face a tokenized Solr field, so they facet on words
    rather than values — border returns 'border', 'borderless' and 'design',
    where 'borderless design' is one value split in two. Hidden here until the
    fields are removed from the Solr facet list.
  */
  'backing',
  'border'
];

/*
  Raw field -> the curated field that replaces it when the curated one has
  values. Area Rugs now ship sizeFilters and colorFilters: tidy, merchandised
  lists in place of variantOptions (92 size spellings, mixed case) and
  color_family (92 colour values). Everything else still returns the curated
  fields empty, so carpet, tile and LVP keep color_family and lose nothing.

  Expressed as a supersede rule rather than a plain hide so the raw field
  reappears by itself if the curated data is ever missing, instead of leaving
  the collection with no size or colour filter at all.
*/
var RR_SUPERSEDED_FACETS = {
  variantOptions: 'sizeFilters',
  color_family: 'colorFilters',
  /*
    style holds the manufacturer's pattern names — 'CK024 Irradiant',
    'Atlantic Avenue' — which are catalogue identifiers, not a browse axis.
    styleFilters is the merchandised version ('Modern'). Both carry the label
    "Style", so without this the sidebar shows two panels of that name.
  */
  style: 'styleFilters'
};

/*
  Hidden on Area Rugs only. 'look' cannot go in the list above: carpet, tile and
  LVP filter on it heavily (Flecked Texture 585, Solid Texture 497), so a flat
  hide would strip a real filter from three quarters of the catalogue. On rugs
  it overlaps what Style already says.

  A response counts as rugs when it carries the curated rug fields, which no
  other product type returns with values — the same test the supersede rule uses,
  so neither needs to know which collection is on screen.
*/
var RR_HIDDEN_FACETS_RUGS = ['look'];

function isRugResponse(facetFilters) {
  if (!facetFilters) { return false; }
  var markers = ['sizeFilters', 'colorFilters', 'shapeFilters'];
  for (var i = 0; i < markers.length; i++) {
    if (facetFilters[markers[i]] && facetFilters[markers[i]].length > 0) { return true; }
  }
  return false;
}

function isHiddenFacet(key, facetFilters) {
  if (RR_HIDDEN_FACETS.indexOf(String(key).toLowerCase()) !== -1) { return true; }
  if (isRugResponse(facetFilters) &&
      RR_HIDDEN_FACETS_RUGS.indexOf(String(key).toLowerCase()) !== -1) { return true; }
  var replacement = RR_SUPERSEDED_FACETS[key];
  if (replacement && facetFilters && facetFilters[replacement] && facetFilters[replacement].length > 0) {
    return true;
  }
  return false;
}

/*
  Booleans are stored as literal true/false but read badly in a sidebar, so they
  are shown as Yes/No. Display only — facetOption.value, which formQuery() turns
  into the Solr phrase, keeps the stored spelling. madeInUSA already stores
  'Yes'/'No' and falls through untouched.
*/
function facetValueLabel(value) {
  var v = String(value).trim().toLowerCase();
  if (v === 'true') { return 'Yes'; }
  if (v === 'false') { return 'No'; }
  return humanize(String(value));
}

/*
  Fields merged into a single "Features" panel, in display order. Each is a
  small yes/no or one-value field that reads as clutter on its own — five
  panels of two options each — but as a list of things a rug *is*, they read
  as one question.

  The Solr field stays on each checkbox (data-facet-field), because the merged
  panel holds boxes from several fields and formQuery() can no longer infer the
  field from the form it sits in.

  indoorOutdoor is listed but is not yet faceted by the service: it exists on
  the documents and returns no facet values, so it simply does not appear.
  Nothing else is needed here once the service facets it.
*/
var RR_FEATURE_FACETS = [
  'petFriendly',
  'ecoFriendly',
  'machineWashable',
  'indoorOutdoor',
  'construction'
];

var RR_AFFIRMATIVE = ['true', 'yes'];
var RR_NEGATIVE = ['false', 'no'];

function isBooleanFacet(values) {
  for (var i = 0; i < values.length; i++) {
    var v = String(values[i]).trim().toLowerCase();
    if (RR_AFFIRMATIVE.indexOf(v) === -1 && RR_NEGATIVE.indexOf(v) === -1) { return false; }
  }
  return values.length > 0;
}

/*
  Turns one field's [value, count, value, count] into Features options.

  A boolean field contributes at most one option, labelled with the field name
  ("Pet Friendly") rather than the value — inside a feature list, "Pet Friendly:
  Yes / No" is noise, and nobody filters for rugs that are *not* pet friendly.
  A field whose only value is the negative one (machineWashable is 'no' across
  the board today) contributes nothing, which is correct: there is nothing to
  narrow to.

  A value field contributes one option per value, labelled by the value.
*/
function featureOptionsFor(field, rawfacetOptions) {
  var values = [], counts = [], options = [], i;
  for (i = 0; i < rawfacetOptions.length; i = i + 2) {
    values.push(rawfacetOptions[i]);
    counts.push(rawfacetOptions[i + 1]);
  }
  if (isBooleanFacet(values)) {
    for (i = 0; i < values.length; i++) {
      if (RR_AFFIRMATIVE.indexOf(String(values[i]).trim().toLowerCase()) !== -1 && counts[i] > 0) {
        options.push({
          id: convertToId(field + '-' + values[i]),
          value: values[i],
          field: field,
          label: mapFilterHeadings(humanize(field)),
          count: counts[i]
        });
      }
    }
    return options;
  }
  for (i = 0; i < values.length; i++) {
    options.push({
      id: convertToId(field + '-' + values[i]),
      value: values[i],
      field: field,
      label: facetValueLabel(values[i]),
      count: counts[i]
    });
  }
  return options;
}

function buildFacetForProducts(facetFilters, totalResultCount) {
  var $productFacetContainer = $('#accordion');
      
      $productFacetContainer.empty();
      var facets = [],
      data = {}, 
      source = $("#ProductFacetTemplate").html(),
      template = Handlebars.compile(source);

      var featureOptions = [];

      for (var key in facetFilters) {
        var rawfacetOptions = facetFilters[key];
        if (facetFilters.hasOwnProperty(key) && rawfacetOptions.length > 0 && !isHiddenFacet(key, facetFilters)) {
          if (RR_FEATURE_FACETS.indexOf(key) !== -1) {
            // Collected now, emitted as one panel after the loop.
            continue;
          }
          var facet = {};
          facet.id = key;
          facet.label = mapFilterHeadings(humanize(key));
          var facetOptions = [];
          for(var i=0; i < rawfacetOptions.length; i=i+2) {
            var facetOption = {};
            facetOption.id = convertToId(rawfacetOptions[i]);
            facetOption.value = rawfacetOptions[i];
            facetOption.field = key;
            facetOption.label = facetValueLabel(rawfacetOptions[i]);
            facetOption.count = rawfacetOptions[i+1];
            facetOptions.push(facetOption);
            /*if(facetOption.count != totalResultCount) {
              facetOptions.push(facetOption);
            }*/
          }
          facet.facetOptions = facetOptions;
          if(facetOptions.length > 0) {
            facets.push(facet);
          }
        }
      }

  /*
    Features is assembled in the configured order rather than the service's, so
    the list reads the same on every collection.
  */
  for (var fi = 0; fi < RR_FEATURE_FACETS.length; fi++) {
    var ffield = RR_FEATURE_FACETS[fi];
    if (facetFilters[ffield] && facetFilters[ffield].length > 0 && !isHiddenFacet(ffield, facetFilters)) {
      featureOptions = featureOptions.concat(featureOptionsFor(ffield, facetFilters[ffield]));
    }
  }
  if (featureOptions.length > 0) {
    facets.push({ id: 'features', label: 'Features', facetOptions: featureOptions });
  }

  /*
    Panel order follows the service's field order otherwise, which is arbitrary
    to a shopper. Sort by the displayed label — the one mapFilterHeadings()
    produces — so the sidebar reads Brand, Color Family, Life Style Rooms, ...
    rather than Type, Brand, Style. The values inside each panel already arrive
    alphabetically from Solr.

    Exception: the panels a shopper actually narrows by lead, in the order they
    tend to decide — Size, then Style, then Colour. Size is first because a rug
    that does not fit the room is not a candidate whatever it looks like.

    No collection check is needed for Size: variantOptions is populated for Area
    Rugs only (every other product type returns it empty, so the panel is not
    built at all), which is why this is a pinned field list rather than an 'if
    this is the rug collection' branch. Style and Color Family exist across
    product types, so they lead everywhere — on a carpet collection the order is
    simply Style, Color Family, then the rest alphabetically.
  */
  var RR_PINNED_FACETS = [
    'sizeFilters', 'variantOptions',   // Size, whichever of the two is showing
    'styleFilters', 'style',           // Style
    'colorFilters', 'color_family'     // Colour
  ];
  facets.sort(function(a, b) {
    var pa = RR_PINNED_FACETS.indexOf(a.id);
    var pb = RR_PINNED_FACETS.indexOf(b.id);
    if (pa !== pb) {
      // Pinned fields lead, in the order listed above; everything else follows.
      return (pa === -1 ? RR_PINNED_FACETS.length : pa) - (pb === -1 ? RR_PINNED_FACETS.length : pb);
    }
    return String(a.label).localeCompare(String(b.label));
  });

  data = {
      facets: facets
  } 

  $productFacetContainer.append(template(data));
  populateCheckedFields();
}

function populateCheckedFields() {
var selectedDataFilters = [];
if(selectedFields.size > 0) {
  selectedFields.forEach(function(value, key){
    /*
      A facet's entry is a flat [id, value, id, value, ...] list — formQuery()
      pushes one pair per checked box, so multi-select facets (variantOptions,
      lifeStyleRooms) hold several. Reading only value[0]/value[1] re-checked
      and listed just the first one after the sidebar re-rendered, and since
      the next formQuery() reads the DOM rather than this map, the rest then
      dropped out of the query on the following interaction.
    */
    for (var i = 0; i < value.length; i = i + 2) {
      // .prop, not .attr: these checkboxes are re-created on every response and
      // the property is what ':checked' and formQuery() read back.
      // Scoped to .facetOptions rather than to '#' + key: a Features box lives in
      // the merged panel, not in a form named after its Solr field. Ids are
      // unique (convertToId hashes the value), and the scope also avoids the
      // duplicate id the selected-filter chip carries.
      $('.facetOptions').find('#' + value[i]).prop('checked', true);
      selectedDataFilters.push({
        facetId: key,
        id: value[i],
        value: value[i + 1],
        // The chip is the same value seen twice: raw for the input, Yes/No for the eye.
        label: facetValueLabel(value[i + 1])
      });
    }
  });
}
  populateProductSelectedFacet(selectedDataFilters);
}

function populateProductSelectedFacet(selectedDataFilters) {
var $productSelectedFacetContainer = $('#selectedFilter');
      
      $productSelectedFacetContainer.empty();
      var facets = [],
      data = {}, 
      source = $("#ProductSelectedFacetTemplate").html(),
      template = Handlebars.compile(source);			  
  data = {
      selectedFacets: selectedDataFilters
  } 

  $productSelectedFacetContainer.append(template(data));
}

function reverseObject(obj) {
  var facetReversed = [];
  if(obj.size > 0) {
    obj.forEach(function(value, key){
      var selectedDataFilter = {};
      selectedDataFilter.facetId = key;
      selectedDataFilter.id = value[0];
      selectedDataFilter.value = value[1];
      const filterOption = key;
      const filterValues = value;
      $('#' + filterOption).find("#" + filterValues[0]).attr('checked', true);
      facetReversed.push(selectedDataFilter);
    });
  }
  return facetReversed.reverse();
};

/*
  Facet values are dropped into a Solr phrase inside a URL: field:("<value>").
  Area Rug sizes are the first values to contain a double quote — 2' 6" X 10' —
  which closes the phrase early and makes Solr return 400 rather than an empty
  result, so the grid silently stops updating. Backslash-escape the Lucene
  metacharacters, then percent-encode so the phrase survives the query string
  too (a value containing & or # would otherwise truncate the whole q param).
*/
function escapeFacetValue(value) {
  return encodeURIComponent(String(value).replace(/([\\"])/g, '\\$1'));
}

function formQuery() {
var filterQuery = serviceUrl + "/search?q=productEnabled:true AND " + collectioTitle;
let i = 0;
let facetsSelected = false;
/*
  Checked boxes are grouped by their Solr field, taken from the box itself.
  It used to come from the enclosing form's id, which worked while one panel
  meant one field — the Features panel breaks that, holding boxes from
  petFriendly, ecoFriendly, construction and the rest at once. data-facet-field
  is set on every option, so ordinary panels behave exactly as before.
*/
var grouped = {};
var fieldOrder = [];
$('.facetOptions').find('input:checkbox:checked').each(function(){
  var $box = $(this);
  var field = $box.attr('data-facet-field') || $box.closest('.facetOptions').attr('id');
  if (!field) { return; }
  if (!grouped[field]) { grouped[field] = []; fieldOrder.push(field); }
  grouped[field].push({ id: $box.attr('id'), value: $box.attr('value') });
});

selectedFields.clear();
for (var fq = 0; fq < fieldOrder.length; fq++) {
  var qField = fieldOrder[fq];
  var picks = grouped[qField];
  var phrases = [];
  var facetOptionArray = [];
  for (var pi = 0; pi < picks.length; pi++) {
    phrases.push('"' + escapeFacetValue(picks[pi].value) + '"');
    facetOptionArray.push(picks[pi].id);
    facetOptionArray.push(picks[pi].value);
  }
  facetsSelected = true;
  i = i + 1;
  filterQuery = filterQuery + ' AND ' + qField + ':(' + phrases.join(' OR ') + ')';
  selectedFields.set(qField, facetOptionArray);
}
filterQuery = filterQuery +"&start="+ currentstart+ "&rows=" + currentrows;
if(sortOption !== "") {
  filterQuery = filterQuery + "&sort=" + sortOption;
}
return filterQuery;
}

function filterResults(){
currentrows = productPerPage;
currentstart = 0;
if($('input:checkbox:checked').length === 0) {
  selectedFields.clear();
  getFilterProducts(baseProductUrl);
} else {
  fetchSearchResults();
}
}

function removeFilter(filterId, facetId) {
$('.facetOptions').find('#' + filterId).prop('checked', false);
filterResults();
}

function toggleFav(productData) {
  if(productData.isFav) {
    removeFav(productData);
  } else {
    addFav(productData);
  }
  if (RR_SSR_GRID_ACTIVE) {
    // Re-paint the stars in place; rebuilding would discard the server grid.
    rrHydrateSsrFavourites();
  } else {
    buildFilteredProducts(filteredResults);
  }
  checkAnUpdateFavStar();
}

function checkAndGoToSpecificPage(browserBack) {
  var pageNum = '';
  if(location.search.indexOf('pg') !== -1) {
    let urlParams = new URLSearchParams(window.location.search);
    pageNum = urlParams.get('pg');
    // pageNum = location.hash.replace("#pg=", '');
  }
  if(browserBack && pageNum === '') {
    pageNum = 1;
  }
  if(pageNum !== '') {
    fetchPage(pageNum);
  }
}

/* =========================================================
   Free-sample buttons on collection cards (Phase 2 wiring)
   The search index has no sample flag, so we detect a sample by probing
   /products/{handle}-sample.js — a 200 means a sample exists and gives us
   the sample variant id; a 404 means no sample. Results are cached in
   sessionStorage so pagination/filtering doesn't refetch. Clicking adds the
   sample via a /cart/add form POST, mirroring the product page sample form.
   ========================================================= */
var RR_SAMPLE_CACHE = {};
try { RR_SAMPLE_CACHE = JSON.parse(sessionStorage.getItem('rrSampleCache') || '{}'); } catch (e) { RR_SAMPLE_CACHE = {}; }

function rrPersistSampleCache() {
  try { sessionStorage.setItem('rrSampleCache', JSON.stringify(RR_SAMPLE_CACHE)); } catch (e) {}
}

function rrApplySampleResult($btn, variantId) {
  if (variantId) {
    $btn.attr('data-sample-id', variantId).removeAttr('hidden');
  } else {
    $btn.remove();
  }
}

function rrCheckSampleForButton(btn) {
  var $btn = $(btn);
  if ($btn.data('sampleChecked')) return;
  $btn.data('sampleChecked', true);
  var handle = $btn.attr('data-handle');
  if (!handle) { $btn.remove(); return; }

  var cached = RR_SAMPLE_CACHE[handle];
  if (cached !== undefined) { rrApplySampleResult($btn, cached); return; }

  fetch('/products/' + handle + '-sample.js', { headers: { 'Accept': 'application/json' } })
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (p) {
      var vid = false;
      if (p && p.variants && p.variants.length) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        vid = (v && v.id) || false;
      }
      RR_SAMPLE_CACHE[handle] = vid;
      rrPersistSampleCache();
      rrApplySampleResult($btn, vid);
    })
    .catch(function () { RR_SAMPLE_CACHE[handle] = false; $btn.remove(); });
}

/*
  Storefront enrichment for multi-variant products (Area Rugs: one variant per size).

  The search service indexes a single `price` per product and no variant count,
  so a rug card would advertise $549 for a rug that runs to $3,549, and the
  quick-buy overlay would silently add the cheapest size. Both need the real
  product, so it is fetched once per handle and cached for the session — the same
  fetch-after-render pattern as the Free Sample buttons below.

  Two things are applied when it resolves:
    - the price becomes a range ($549 – $3,549)
    - the Add to Cart button becomes "Choose a Size" and links to the PDP
      instead of opening quick-buy, because size is the purchase decision for a
      rug and the overlay has no size selector.

  When the service starts indexing price_min/price_max/variant_count this can
  read them directly and the fetch can go away.
*/
var RR_PRODUCT_CACHE = {};
try { RR_PRODUCT_CACHE = JSON.parse(sessionStorage.getItem('rrProductCache') || '{}'); } catch (e) { RR_PRODUCT_CACHE = {}; }

function rrPersistProductCache() {
  try { sessionStorage.setItem('rrProductCache', JSON.stringify(RR_PRODUCT_CACHE)); } catch (e) {}
}

// 54900 -> "549", 354900 -> "3,549", 299 -> "2.99". Cards stay compact by
// dropping ".00" on whole-dollar amounts.
function rrFormatCents(cents) {
  var amount = Number(cents) / 100;
  var decimals = amount % 1 === 0 ? 0 : 2;
  return amount.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/* Fetch (or replay from cache) the variant facts we need for one handle. */
function rrFetchProductInfo(handle) {
  var cached = RR_PRODUCT_CACHE[handle];
  if (cached !== undefined) { return Promise.resolve(cached); }
  return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (p) {
      /*
        compare_at_price lives per variant, so the was-price range is derived
        here rather than read off the product. Only variants actually discounted
        count — an undiscounted variant reports compare_at_price as null or as
        its own price, and including those would understate the saving.
      */
      var cmpMin = null, cmpMax = null;
      ((p && p.variants) || []).forEach(function (v) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (cmpMin === null || v.compare_at_price < cmpMin) { cmpMin = v.compare_at_price; }
          if (cmpMax === null || v.compare_at_price > cmpMax) { cmpMax = v.compare_at_price; }
        }
      });
      var info = p ? {
        variants: (p.variants || []).length,
        varies: !!p.price_varies,
        min: p.price_min,
        max: p.price_max,
        compareMin: cmpMin,
        compareMax: cmpMax
      } : null;
      RR_PRODUCT_CACHE[handle] = info;
      rrPersistProductCache();
      return info;
    })
    .catch(function () {
      RR_PRODUCT_CACHE[handle] = null;
      return null;
    });
}

function rrApplyProductInfo(handle, info) {
  if (!info) return;

  if (info.varies && info.max && info.max !== info.min) {
    $('[data-pc-price-range="' + handle + '"]').each(function () {
      var $el = $(this);
      var unit = $el.find('.denomination').first();
      var unitHtml = unit.length ? unit.prop('outerHTML') : '';
      $el.html('$' + rrFormatCents(info.min) + ' &ndash; $' + rrFormatCents(info.max) + unitHtml);
    });
  }

  /*
    Was-price beside the card price, as the rug PDP shows it. Appended to every
    card for this handle, including the server-rendered ones, which already
    carry it from Liquid — hence the guard against adding a second copy.
  */
  if (info.compareMax) {
    var compareHtml = info.compareMin && info.compareMin !== info.compareMax
      ? '$' + rrFormatCents(info.compareMin) + ' &ndash; $' + rrFormatCents(info.compareMax)
      : '$' + rrFormatCents(info.compareMax);
    $('[data-pc-price-range="' + handle + '"], [data-pc-variant-check="' + handle + '"]')
      .closest('.pc-card').find('.pc-price').each(function () {
        var $price = $(this);
        if ($price.find('.pc-price__compare').length) { return; }
        $price.append('<span class="pc-price__compare">' + compareHtml + '</span>');
      });
  }

  /*
    More than one variant means the shopper has to choose a size, which the
    quick-buy overlay cannot offer — send them to the product page instead of
    adding the cheapest size behind their back.
  */
  if (info.variants > 1) {
    $('[data-pc-variant-check="' + handle + '"]')
      .attr('data-multi-variant', '1')
      .attr('data-action', 'choose-size')
      .text('Choose a Size');
  }
}

function enhanceProductCards() {
  var handles = {};
  $('[data-pc-price-range], [data-pc-variant-check]').each(function () {
    var $el = $(this);
    var handle = $el.attr('data-pc-price-range') || $el.attr('data-pc-variant-check');
    if (handle) handles[handle] = true;
  });
  Object.keys(handles).forEach(function (handle) {
    rrFetchProductInfo(handle).then(function (info) { rrApplyProductInfo(handle, info); });
  });
}

function enhanceSampleButtons() {
  $('.pc-sample').each(function () { rrCheckSampleForButton(this); });
}

function rrUpdateCartCount() {
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      $('.cart .badge').text(cart.item_count);
    })
    .catch(function () {});
}

/* Add the sample via the AJAX cart API so the shopper stays on the listing. */
function rrAddSampleToCart(variantId, $btn) {
  var original = $btn ? $btn.html() : null;
  if ($btn) { $btn.prop('disabled', true).addClass('is-loading'); }
  // rrCartDrawerAdd (global.js) adds via AJAX and opens the cart flyout drawer
  var add = window.rrCartDrawerAdd
    ? window.rrCartDrawerAdd(variantId, 1)
    : fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  add
    .then(function () {
      rrUpdateCartCount();
      if ($btn) {
        $btn.removeClass('is-loading').addClass('is-added').html('<i class="fas fa-check"></i> Added');
        setTimeout(function () {
          $btn.removeClass('is-added').prop('disabled', false).html(original);
        }, 2200);
      }
    })
    .catch(function () {
      if ($btn) { $btn.removeClass('is-loading').prop('disabled', false).html(original); }
      window.rrNotify("Sorry, we couldn't add that sample. Please try again.");
    });
}

$(document).on('click', '.pc-sample', function (e) {
  e.preventDefault();
  var id = $(this).attr('data-sample-id');
  if (!id) { return; }
  var $btn = $(this);
  // enforce the 3-samples-per-order limit before adding
  if (typeof window.rrCheckSampleLimit === 'function') {
    window.rrCheckSampleLimit(function (allowed) {
      if (allowed) { rrAddSampleToCart(id, $btn); }
      else { window.rrNotify(window.rrSampleLimitMessage || 'There is a limit of 3 sample per order, you reached max 3 sample for this cart', window.rrSampleLimitTitle || 'Sample Limit'); }
    });
  } else {
    rrAddSampleToCart(id, $btn);
  }
});

/* =========================================================
   "Buy by the box" quick-buy overlay
   Storefront pages send X-Frame-Options: DENY, so they can't be iframed.
   Instead we fetch the trimmed product page (?view=quickbuy, rendered with no
   layout so it's a bare fragment) and inject it into the modal. The fragment
   drops the image gallery, alternate colors, product details and specs — just
   the buy panel. Its add-to-cart / sample forms POST to /cart/add normally
   (they're part of this page now), navigating to /cart.
   ========================================================= */
function rrOpenQuickBuy(url) {
  if (!url) return;
  var $modal = $('#pc-quickbuy');
  if (!$modal.length) { window.location.href = url; return; }
  var sep = url.indexOf('?') > -1 ? '&' : '?';
  var $content = $modal.find('.pc-modal__content');
  $content.empty();
  $modal.find('.pc-modal__loader').show();
  $modal.addClass('is-open').attr('aria-hidden', 'false');
  $('body').addClass('pc-modal-open');
  fetch(url + sep + 'view=quickbuy', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.text(); })
    .then(function (html) {
      $modal.find('.pc-modal__loader').hide();
      $content.html(html);
      var $car = $content.find('.quickbuy-carousel');
      if ($car.length && $.fn.owlCarousel) {
        $car.owlCarousel({
          items: 1, loop: false, nav: true, dots: false, margin: 10, autoHeight: true,
          navText: ['<i class="fas fa-chevron-left"></i>', '<i class="fas fa-chevron-right"></i>']
        });
        // Owl measures before the remote images finish loading, so the first
        // slide can render blank until a nav click. Refresh once things settle
        // and again as each image loads.
        var refresh = function () { $car.trigger('refresh.owl.carousel'); };
        setTimeout(refresh, 60);
        $car.find('img').each(function () {
          if (this.complete) { refresh(); }
          else { $(this).on('load', refresh); }
        });
      }
    })
    .catch(function () {
      $modal.find('.pc-modal__loader').hide();
      $content.html('<div class="pc-modal__error">Sorry, this product could not be loaded. <a href="' + url + '">Open the product page</a>.</div>');
    });
}

function rrCloseQuickBuy() {
  var $modal = $('#pc-quickbuy');
  if (!$modal.length) return;
  $modal.removeClass('is-open').attr('aria-hidden', 'true');
  $modal.find('.pc-modal__content').empty();
  $('body').removeClass('pc-modal-open');
}

/* box calculator inside the injected quick-buy panel (mirrors product.liquid) */
function rrQbCompute() {
  var $m = $('#pc-quickbuy');
  var coverage = Number($m.find('.quickbuy').attr('data-coverage'));
  var l = $m.find('#length').val(), w = $m.find('#width').val();
  if (l !== '' && w !== '') {
    var sqft = l * w;
    if ($m.find('#check1').is(':checked')) { sqft = sqft + ((sqft * 10) / 100); }
    $m.find('#sqft').val(sqft);
    if (coverage) {
      var boxes = Math.ceil(sqft / coverage);
      $m.find('#input').val(boxes);
      $m.find('#Quantity').val(Number(boxes));
    }
  }
}

$(document).on('click', '.pc-buybox', function (e) {
  var $btn = $(this);
  var url = $btn.attr('data-url') || $btn.attr('href');

  // Known multi-variant: let the anchor navigate to the product page.
  if ($btn.attr('data-multi-variant') === '1') { return; }

  // Range candidate whose variant count has not come back yet — resolve before
  // deciding, so a fast click can never add the wrong size via quick-buy.
  var handle = $btn.attr('data-pc-variant-check');
  if (handle && RR_PRODUCT_CACHE[handle] === undefined) {
    e.preventDefault();
    rrFetchProductInfo(handle).then(function (info) {
      rrApplyProductInfo(handle, info);
      if (info && info.variants > 1) { window.location.href = url; }
      else { rrOpenQuickBuy(url); }
    });
    return;
  }

  e.preventDefault();
  rrOpenQuickBuy(url);
});
$(document).on('click', '[data-pc-close]', function () { rrCloseQuickBuy(); });
$(document).on('keydown', function (e) { if (e.key === 'Escape') rrCloseQuickBuy(); });

/* delegated handlers scoped to the modal (work for injected content) */
$(document).on('keyup', '#pc-quickbuy #length, #pc-quickbuy #width', rrQbCompute);
$(document).on('click', '#pc-quickbuy #check1', rrQbCompute);
$(document).on('change', '#pc-quickbuy #input', function () { $('#pc-quickbuy #Quantity').val(Number($(this).val())); });
$(document).on('click', '#pc-quickbuy #minus', function (e) {
  e.preventDefault();
  var $i = $('#pc-quickbuy #input'); var v = Number($i.val()); v = v > 1 ? v - 1 : 1;
  $i.val(v); $('#pc-quickbuy #Quantity').val(v);
});
$(document).on('click', '#pc-quickbuy #plus', function (e) {
  e.preventDefault();
  var $i = $('#pc-quickbuy #input'); var v = Number($i.val()); v = v >= 1 ? v + 1 : 1;
  $i.val(v); $('#pc-quickbuy #Quantity').val(v);
});
$(document).on('show.bs.collapse', '#pc-quickbuy .collapse', function () {
  $(this).parent().find('.fa').removeClass('fa-plus').addClass('fa-minus');
});
$(document).on('hide.bs.collapse', '#pc-quickbuy .collapse', function () {
  $(this).parent().find('.fa').removeClass('fa-minus').addClass('fa-plus');
});

$(document).ready(function(){

  //var baseProductUrl = "{{ 'products.json' | asset_url }}";
  //var filterProductUrl = "{{ 'product-filtered.json' | asset_url }}";
  if (RR_SSR_GRID_ACTIVE) {
    // Server-rendered cards need the same treatment the JS ones get.
    rrHydrateSsrFavourites();
    enhanceSampleButtons();
    enhanceProductCards();
  }

  getFilterProducts(baseProductUrl);
  checkAndGoToSpecificPage(false);

  $(window).on('popstate', function() {
    checkAndGoToSpecificPage(true);
  });

});